(function(){
var s=document.currentScript||document.querySelector('script[data-logo]');
var logo=s&&s.getAttribute('data-logo'); if(!logo) return;
function isDark(el){var m=getComputedStyle(el).color.match(/\d+(\.\d+)?/g)||[0,0,0];return (0.299*m[0]+0.587*m[1]+0.114*m[2])<140}
function make(ref){
  var dark=isDark(ref),w=document.createElement('span');w.className='ft-hl';w.setAttribute('role','img');w.setAttribute('aria-label','Fashion Tabs');
  var layers='';
  for(var z=-6;z<=6;z+=3){
    var sh=z===6?1:(0.5+0.04*(z+6));
    layers+='<img src="'+logo+'" alt="" style="transform:translateZ('+z+'px);opacity:'+sh.toFixed(2)+(dark?';filter:brightness(0)':'')+'">';
  }
  w.innerHTML='<span class="ft-hl-3d">'+layers+'</span>';
  return w;
}
var UK='<svg viewBox="0 0 60 40"><rect width="60" height="40" fill="#012169"/><path d="M0 0L60 40M60 0L0 40" stroke="#fff" stroke-width="8"/><path d="M0 0L60 40M60 0L0 40" stroke="#C8102E" stroke-width="3"/><path d="M30 0V40M0 20H60" stroke="#fff" stroke-width="13"/><path d="M30 0V40M0 20H60" stroke="#C8102E" stroke-width="8"/></svg>';
var US=(function(){var r='<svg viewBox="0 0 60 40"><rect width="60" height="40" fill="#fff"/>';for(var i=0;i<13;i+=2)r+='<rect y="'+(i*40/13).toFixed(2)+'" width="60" height="'+(40/13).toFixed(2)+'" fill="#B22234"/>';
  r+='<rect width="26" height="21.5" fill="#3C3B6E"/>';for(var y=0;y<4;y++)for(var x=0;x<5;x++)r+='<circle cx="'+(3.6+x*4.6)+'" cy="'+(3.4+y*4.8)+'" r="1" fill="#fff"/>';return r+'</svg>'})();
var FL={GB:UK,US:US},CODE={GB:'GBP',US:'USD'};
function fl(c){return '<span class="fl">'+FL[c]+'</span>'}
function buildCurrency(form){
  var btns=[].slice.call(form.querySelectorAll('button[data-cc]')),cur='GB';
  btns.forEach(function(b){if(b.getAttribute('aria-pressed')==='true')cur=b.getAttribute('data-cc')});
  var input=form.querySelector('input[name="country_code"]');
  btns.forEach(function(b){b.remove()});
  var tr=document.createElement('button');tr.type='button';tr.className='tr';tr.setAttribute('aria-haspopup','true');tr.setAttribute('aria-expanded','false');tr.setAttribute('aria-label','Currency: '+CODE[cur]);
  tr.innerHTML=fl(cur)+'<svg class="chev" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3.5L5 6.5L8 3.5"/></svg>';
  var menu=document.createElement('div');menu.className='menu';menu.hidden=true;
  ['GB','US'].forEach(function(c){var b=document.createElement('button');b.type='button';b.setAttribute('data-cc',c);if(c===cur)b.setAttribute('aria-current','true');b.innerHTML=fl(c)+'<span>'+CODE[c]+'</span>';
    b.addEventListener('click',function(){if(c===cur){close();return}input.value=c;form.submit()});menu.appendChild(b)});
  function close(){menu.hidden=true;tr.setAttribute('aria-expanded','false')}
  tr.addEventListener('click',function(e){e.stopPropagation();var o=menu.hidden;menu.hidden=!o;tr.setAttribute('aria-expanded',o)});
  document.addEventListener('click',function(e){if(!form.contains(e.target))close()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  form.appendChild(tr);form.appendChild(menu);
}
function run(){
  document.querySelectorAll('.ft header .mark img').forEach(function(i){i.remove()});
  var fm=document.querySelector('.ft footer .mark');
  if(fm){
    if(!fm.querySelector('.ft-hl')){fm.querySelectorAll('img').forEach(function(i){i.remove()});fm.insertBefore(make(fm),fm.firstChild)}
  }else if(!document.querySelector('.ft')){
    var f=document.querySelector('footer');
    if(f&&!f.querySelector('.ft-hl-foot')){var d=document.createElement('div');d.className='ft-hl-foot';d.appendChild(make(d));f.appendChild(d)}
  }
  var tpl=document.getElementById('ft-loc'),tools=document.querySelector('.ft .tools');
  if(tpl&&tools&&!tools.querySelector('.ft-cur')){
    tools.insertBefore(tpl.content.cloneNode(true),tools.firstChild);
    var form=tools.querySelector('.ft-cur');if(form)buildCurrency(form);
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
document.addEventListener('shopify:section:load',run);
// A restored page can retain open menus and partially hidden reveal animations.
window.addEventListener('pageshow',function(event){
  document.querySelectorAll('.ft-cur[open]').forEach(function(menu){menu.open=false});
  document.querySelectorAll('.ft-cur form').forEach(function(form){delete form.dataset.submitting;form.removeAttribute('aria-busy')});
  if(event.persisted){
    document.documentElement.classList.remove('ft-intro-on');
    document.querySelectorAll('.ft-intro,.ft-spin').forEach(function(overlay){overlay.remove()});
    document.querySelectorAll('.ft .rv').forEach(function(element){element.classList.add('in')});
  }
});
document.addEventListener('submit',function(event){
  var form=event.target;
  if(!form.matches('.ft-cur form'))return;
  if(form.dataset.submitting==='true'){event.preventDefault();return}
  form.dataset.submitting='true';form.setAttribute('aria-busy','true');
  // Leave the chosen submit button enabled so country_code is included in the POST.
  requestAnimationFrame(function(){var menu=form.closest('details');if(menu)menu.open=false});
});
})();